// extracted by mini-css-extract-plugin
export var grid = "_q-0";
export var span1 = "_q-2";
export var span10 = "_q-b";
export var span10L = "_q-z";
export var span10M = "_q-n";
export var span10Xl = "_q-1b";
export var span11 = "_q-c";
export var span11L = "_q-10";
export var span11M = "_q-o";
export var span11Xl = "_q-1c";
export var span12 = "_q-d";
export var span12L = "_q-11";
export var span12M = "_q-p";
export var span12Xl = "_q-1d";
export var span1L = "_q-q";
export var span1M = "_q-e";
export var span1Xl = "_q-12";
export var span2 = "_q-3";
export var span2L = "_q-r";
export var span2M = "_q-f";
export var span2Xl = "_q-13";
export var span3 = "_q-4";
export var span3L = "_q-s";
export var span3M = "_q-g";
export var span3Xl = "_q-14";
export var span4 = "_q-5";
export var span4L = "_q-t";
export var span4M = "_q-h";
export var span4Xl = "_q-15";
export var span5 = "_q-6";
export var span5L = "_q-u";
export var span5M = "_q-i";
export var span5Xl = "_q-16";
export var span6 = "_q-7";
export var span6L = "_q-v";
export var span6M = "_q-j";
export var span6Xl = "_q-17";
export var span7 = "_q-8";
export var span7L = "_q-w";
export var span7M = "_q-k";
export var span7Xl = "_q-18";
export var span8 = "_q-9";
export var span8L = "_q-x";
export var span8M = "_q-l";
export var span8Xl = "_q-19";
export var span9 = "_q-a";
export var span9L = "_q-y";
export var span9M = "_q-m";
export var span9Xl = "_q-1a";
export var stretch = "_q-1";